module.exports = __webpack_public_path__ + "img/ouessant_cover.9af915ad.jpg";